export default "__VITE_ASSET__CDVh85Gv__"